import { applyMuiLicense } from "./muiLicense.ts";

applyMuiLicense();
